import { render } from "./NewsletterRegister.vue?vue&type=template&id=6671ef78"
import script from "./NewsletterRegister.vue?vue&type=script&lang=js"
export * from "./NewsletterRegister.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp64\\www\\safest\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__